export enum Route {
	DETAILS_OVERVIEW = 'DetailsOverView',
	AVAILABILITY_OVERVIEW = 'AvailabilityOverview',
	POS_MATERIAL_OVERVIEW = 'PosMaterialOverview',
}
